module.exports = __webpack_public_path__ + "img/close_modal.a58c3abf.svg";